var functions = {
	data: [],
	currentData: [],
	currentCat: "",
	canChange: true,
	lang: "",
	isFirst: true,
	init: function(){
		let dir = location.pathname;
		let dirArry = dir.split("/");
		functions.lang = dirArry[1];
		let url = `${path}assets/json/functions_${functions.lang}.json`;
		load.getJson(url, {}).done(function(json){
			functions.data = json;
			console.log(json)
			functions.getCategory(json);
			
			functions.checkURL();
		});
	},
	checkURL: function(){
		let param 	= location.search.substring(1),
		pair 	= param.split('&'),
		hasToken = false;
	
		if(param === ""){
			//alert("パラメータがありません")
			functions.sortByCat();
		}else{
			for(var i = 0; pair[i]; i++) {
				var kv = pair[i].split('=');
				if(kv[0] === "category"){
					functions.currentCat = kv[1];
					hasToken = true;
				}
			}
			functions.sortByCat();
		}
	},
	nav: function(){
		$(".tags li a").off().on("click", function(){
			let $this = $(this);
			if(functions.canChange){
				functions.canChange = false;
				if( $this.attr("data-name") === "all" ){
					functions.currentCat = "";
				}else{
					functions.currentCat = $(this).attr("data-name");
				}
				
				functions.changeURL();
			}
		});
		$(".nav_function li a").off().on("click", function(){
			let $this = $(this);
			if(functions.canChange){
				$(".nav_function li a").removeClass("active");
				$this.addClass("active");
				functions.canChange = false;
				if( $this.attr("data-name") === "all" ){
					functions.currentCat = "";
				}else{
					functions.currentCat = $(this).attr("data-name");
				}
				
				functions.changeURL();
			}
		});
	},
	changeURL: function(){
		let path = "";
		if(functions.currentCat === ""){
			path = "?category=all";
		}else{
			path = "?category=" + functions.currentCat;
		}
		$("#block_function").addClass("disable");
		functions.canChange = false;
		setTimeout(function(){
			window.history.pushState(null, null, path);
			functions.checkURL();	
		}, 400);
	},
	getCategory: function(json){
		let categories = [];
		let before = "";
		let navHTML = "";
		navHTML += `<li><a class="all" href="javascript:void(0);" data-category="all" title="ALL"><span>ALL</span></a></li>`
		for(var i = 0; i < json.length; i++){
			let d = json[i];
			let c = d.category;
			if(c != before){
				let hasThis = false;
				for(var j = 0; j < categories.length; j++){
					let cc = categories[j];
					if(c === cc){
						hasThis = true;
					}
				}
				if(!hasThis){
					categories.push(c);
					navHTML += `<li><a class="${d.slug}" href="javascript:void(0);" data-category="${d.slug}" title="${d.category}"><span>${d.category}</span></a></li>`;
				}
			}
			$("#nav_category ul").html(navHTML);
		}
		//console.log(categories);
	},
	sortByCat: function(){
		let currentCat = functions.currentCat;
		$("#block_function ul").removeClass(function(index, className) {
			return (className.match(/\bsort_\S+/g) || []).join(' ');
		});
		common.scrollToPosition(0, 600);
		if(currentCat === "" || currentCat === "all"){
			//console.log("すべて表示");
			$(".nav_function li a").removeClass("active");
			$(".nav_function li").eq(0).find("a").addClass("active");
		}else{
			$(".nav_function li a").removeClass("active");
			$(".nav_function li").find("." + functions.currentCat).addClass("active");
			$("#block_function ul").addClass("sort_" + functions.currentCat);
		}
		setTimeout(function(){
			if( $("#block_function").hasClass("disable") ){
				$("#block_function").removeClass("disable");
				functions.canChange = true;
			}
		}, 500);
		if(functions.isFirst){
			functions.makeHTML();
		}
	},
	makeHTML: function(){
		let HTML = "";
		for(var i = 0; i < functions.data.length; i++){
			let a = functions.data[i];
			//console.log(i, a);
			let learnMore = "";
			if( functions.lang === "en" ){
				learnMore = "Learn more";
			}else{
				learnMore = "もっと詳しく";
			}
			let tagArry = [];
			let t = a.tags;
			tagArry = a.tags.split(",");
			let tags = "";
			let tagcls = "";
			for(var j = 0; j < tagArry.length; j++){
				let name = "";
				if(tagArry[j] === "fp"){
					name = "fp";
				}else if(tagArry[j] === "fp L"){
					name = "fpl";
				}else if(tagArry[j] === "STILLモード"){
					name = "stillmode";
				}else if(tagArry[j] === "CINEモード"){
					name = "cinemode";
				}else if(tagArry[j] === "STILL MODE"){
					name = "stillmode";
				}else if(tagArry[j] === "CINE MODE"){
					name = "cinemode";
				}
				tagcls += " " + name;
				tags += `<li><a href="javascript:void(0);" title="fp" data-name="${name}"><span>${tagArry[j]}</span></a></li>`
			}
			HTML += `<li class="f${tagcls}">
						<div class="ttl_h3">
							<h3>${a.title}</h3>
						</div>
						<div class="content">
							<div class="txt">
								<p>${a.content}</p>
							</div>
							<div class="tags">
								<ul>${tags}</ul>
							</div>
						</div>
					</li>`;
		}
		$("#block_function ul").html(HTML);
		functions.isFirst = false;
		setTimeout(function(){
			$("#block_function").removeClass("disable");
			functions.canChange = true;
			functions.nav();
			if( $("body").hasClass("disable") ){
				$("body").removeClass("disable");
			}
		}, 200);
	}
}